import { Dropdown } from 'react-bootstrap'
import { DropdownItemProps } from 'react-bootstrap/esm/DropdownItem'
import { useAccess } from 'contexts/AccessContext'

/**
 * Ítem de descarga de reporte: no se renderiza sin `downloadReport`.
 */
export const DropdownReport = ({ disabled, ...props }: DropdownItemProps) => {
  const { access } = useAccess()
  if (!access.canDownloadReportWithViewAccess()) return null

  return <Dropdown.Item className="pr-2" disabled={disabled} {...props} />
}
